// src/components/ActionDropDown.jsx
import React from 'react';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import {
  FaEllipsisV,
  FaEye,
  FaDownload,
  FaEdit,
  FaShareAlt,
  FaLink,
  FaUndoAlt,
  FaTrash
} from 'react-icons/fa';

export default function ActionDropDown({
  object,
  onDetails,
  onPreview,
  onDownload,
  onEdit,
  onShare,
  onCopyLink,
  onRevoke,
  onPublishFolder,
  onDelete
}) {
  const isFolder = object.Key.endsWith('/');

  return (
    <Dropdown as={ButtonGroup}>
      <Dropdown.Toggle split variant="light" id="dropdown-split-actions">
        <FaEllipsisV />
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        {/* Publicar Pasta (somente para pastas) */}
        {isFolder && onPublishFolder && (
          <Dropdown.Item onClick={() => onPublishFolder(object)}>
            <FaLink className="me-2" /> Publicar Pasta
          </Dropdown.Item>
        )}

        {/* Ações gerais */}
        {onDetails && (
          <Dropdown.Item onClick={() => onDetails(object)}>
            <FaEye className="me-2" /> Ver detalhes
          </Dropdown.Item>
        )}
        {onPreview && (
          <Dropdown.Item onClick={() => onPreview(object)}>
            <FaEye className="me-2" /> Pré-visualizar
          </Dropdown.Item>
        )}
        {onDownload && (
          <Dropdown.Item onClick={() => onDownload(object.Key)}>
            <FaDownload className="me-2" /> Baixar
          </Dropdown.Item>
        )}
        {onEdit && (
          <Dropdown.Item onClick={() => onEdit(object)}>
            <FaEdit className="me-2" /> Editar
          </Dropdown.Item>
        )}

        {/* Ações de compartilhamento (somente para arquivos) */}
        {!isFolder && onShare && (
          <Dropdown.Item onClick={() => onShare(object.Key)}>
            <FaShareAlt className="me-2" /> Compartilhar
          </Dropdown.Item>
        )}
        {!isFolder && onCopyLink && (
          <Dropdown.Item onClick={() => onCopyLink(object.Key)}>
            <FaLink className="me-2" /> Copiar link
          </Dropdown.Item>
        )}
        {!isFolder && onRevoke && (
          <Dropdown.Item onClick={() => onRevoke(object.Key)} className="text-danger">
            <FaUndoAlt className="me-2" /> Revogar link
          </Dropdown.Item>
        )}

        {/* Excluir */}
        {onDelete && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => onDelete(object.Key)} className="text-danger">
              <FaTrash className="me-2" /> Excluir
            </Dropdown.Item>
          </>
        )}

        {/* Sem ações disponíveis */}
        {!onDetails && !onPreview && !onDownload && !onEdit && !onShare && !onCopyLink && !onRevoke && !onPublishFolder && !onDelete && (
          <Dropdown.Item disabled>Nenhuma ação disponível</Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
